export function addAccessibilityAttributes(container, metadata) {
    const label = 'aria-label';
    const videoEl = container.querySelector('video');
    const hugePlayBackToggleButton = container.querySelector('.bmpui-ui-hugeplaybacktogglebutton');
    videoEl?.setAttribute(label, metadata.title);
    hugePlayBackToggleButton?.setAttribute(label, metadata.title);
    const description = container.querySelector('.bmpui-label-metadata-description');
    if (description) {
        videoEl?.setAttribute('aria-describedby', description.id);
        hugePlayBackToggleButton?.setAttribute('aria-describedby', description.id);
    }
    const imgRoles = container.querySelectorAll('[role="img"]');
    for (const imgRole of imgRoles) {
        imgRole.setAttribute(label, metadata.title);
    }
    const popupButtons = container.querySelectorAll('[role="pop-up button"]');
    for (const popupButton of popupButtons) {
        popupButton.setAttribute('role', 'button');
        popupButton.setAttribute('aria-haspopup', 'menu');
    }
    const menuItems = container.querySelectorAll('[role="menuitem"][aria-pressed]');
    for (const menuitem of menuItems) {
        menuitem.removeAttribute('aria-pressed');
    }
    const panelItems = container.querySelectorAll('.bmpui-ui-settings-panel-item[role="menuitem"]');
    for (const panelItem of panelItems) {
        panelItem.setAttribute('role', 'group');
    }
    const panelPages = container.querySelectorAll('.bmpui-ui-settings-panel-page.bmpui-listbox-panel[role="menu"]');
    for (const panelPage of panelPages) {
        panelPage.setAttribute('role', 'group');
    }
}
